<script setup lang="ts">
import { computed, defineProps } from "vue";
import { Task } from "@/types/v2";
import { useUsersStore } from "@/stores/v2/";
import { useTask } from "@/composables/tasks/useTask";
import { buildTaskDependencyContext } from "@/utils/v2/tasks/dependencies";
import { useTasksStore } from "@/stores/v2";

import TaskStartModal from "@/components/v2/Dashboard/Tasks/Modals/TaskStartModal.vue";
import TaskItem from "@/components/v2/Dashboard/Tasks/Lists/TaskListItem.vue";

interface TasksListProps {
  tasks: Task[]
}

defineProps<TasksListProps>()

const { showStartTaskModal, selectedTask, handleSelectTask, handleStartTask } = useTask();
const tasksStore = useTasksStore();
const dependencyContextByTaskKey = computed(() =>
  buildTaskDependencyContext(tasksStore.getTasks)
);
</script>

<template>
  <!-- Task items -->
  <TaskItem @click="handleSelectTask(task)" v-for="task in tasks" :key="task.key"
    :currentUser="useUsersStore().getCurrentUser" :task="task"
    :dependencyContext="dependencyContextByTaskKey[task.key]" />

  <!-- No tasks found -->
  <p class="mt-10 text-gray-400" v-if="tasks.length === 0">
    No tasks in this tab...
  </p>

  <!-- Task modal box -->
  <TaskStartModal v-if="showStartTaskModal && selectedTask" :show="showStartTaskModal" :task="selectedTask"
    :currentUser="useUsersStore().getCurrentUser" @start="handleStartTask" @close="showStartTaskModal = false" />
</template>
